export const TOGGLE_NAV = 'TOGGLE_NAV';
export const SET_NAME = 'SET_NAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_MESSAGE = 'SET_MESSAGE';
export const POST_CONTACT = 'POST_CONTACT';
